/**
 * Получение цвета, соответствующего уровню риска
 * @param {string} risk - Уровень риска
 * @returns {string} Цветовой код
 */
export const getRiskColor = (risk) => {
  const lowerRisk = typeof risk === 'string' ? risk.toLowerCase() : '';
  
  switch (lowerRisk) {
    case 'высокий':
    case 'high':
    case 'red':
      return '#d32f2f'; // красный
    case 'средний':
    case 'medium':
    case 'yellow':
    case 'возможный риск':
    case 'possible risk':
      return '#f57c00'; // оранжевый
    case 'низкий':
    case 'low':
    case 'green':
      return '#4caf50'; // зеленый
    case 'нет риска':
    case 'no risk':
    case 'no_risk':
      return '#2979ff'; // синий
    default:
      return '#757575'; // серый (для неизвестных значений)
  }
};

/**
 * Преобразование ключа объекта в удобочитаемую форму
 * @param {string} key - Ключ объекта
 * @returns {string} Отформатированный ключ
 */
export const formatKeyForDisplay = (key) => {
  if (!key) return '';
  
  // Замена подчеркиваний на пробелы и капитализация каждого слова
  return key
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Форматирование булевых значений в текстовый формат
 * @param {boolean} value - Значение
 * @returns {string} Текстовое представление
 */
export const formatBooleanValue = (value) => {
  if (value === true || value === 'true') {
    return 'Да';
  } else if (value === false || value === 'false') {
    return 'Нет';
  }
  return value;
};

/**
 * Format array values to display text
 * @param {Array} value - The array value
 * @returns {string} - Formatted display text
 */
export const formatArrayValue = (value) => {
  if (!Array.isArray(value)) return value;
  
  return value.map((item, index) => {
    if (typeof item === 'string') {
      return index === 0 
        ? item.charAt(0).toUpperCase() + item.slice(1)
        : item;
    }
    return item;
  }).join('; ');
}; 